<template>
    <page>
        <div v-if="options && mockData && form" class="shadow-25" style="height: calc(100vh - 91px);background-color:#FFFDF8;">
            <v-header :title="$metaInfo.title" :icon="options.icon" v-if="displayHeader">
                <template slot="right">
                    <v-button flat rounded dense color="primary"
                              icon="list"
                              :label="$T('go to list')"
                              @click="$router.push({name: `${baseRoute}.index`})">
                    </v-button>
                </template>
            </v-header>
            <card title-inverted
                  title-color="primary"
                  footer-color="white"
                  width="100%">

                <alert :trigger="form.errors.any()"
                       color="negative"
                       icon="error"
                       :html="$T('something went wrong!')"></alert>

                <form @submit.prevent="submit"
                      class="row gutter-sm"
                      @keydown="form.onKeydown($event)">

                    <component v-for="column in options.columns"
                               v-if="hideComponent(column)"
                               :key="column.field"
                               :is="column.component"
                               :path="column.localField || column.field"
                               v-model="form[column.localField || column.field]"
                               :label="$t(column.label) + ((column.rules && column.rules.includes('required')) ? ' *' : '' )"
                               :type="column.type"
                               :inner-label="$t(column.innerLabel)"
                               :min-rows="column.minRows || 3"
                               :options="mockData[column.mockData]"
                               :class="[(column.cols ? column.cols : 'col-md-6 col-xs-12')]"
                               :multiple="column.multiple"
                               :chips="column.chips"
                               :format="column.format"
                               :negative-label="column.negativeLabel"
                               :format24h="column.format24h"
                               :formatData="column.formatData"
                               :max="column.max"
                               :disable="column.disable || extraDisable(column.field)"
                               :form="form"
                               @input="handleFieldChange(column, $event)">
                    </component>

                    <!-- Submit Button -->
                    <div class="col-12 row justify-center q-mt-md" v-if="options.canSave && enableSubmitButton">
                        <v-button :label="submitLabel"
                                  color="primary"
                                  class="no-shadow q-btn-iqos"
                                  :loading="form.busy"
                                  type="submit">
                            <template slot="loading">
                                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                {{ loadingLabel | capitalize }}
                            </template>
                        </v-button>
                    </div>

                </form>

            </card>
        </div>
        <div class="row justify-center items-center row-spinner-height" v-else>
            <spinner-iqos size="60px"/>
        </div>
    </page>
</template>

<script>
    import {QTooltip, QSpinnerPuff} from 'quasar-framework'
    import Form from 'vform'
    import axios from 'axios'
    import {mapGetters} from "vuex";

    export default {
        name: 'AutoForm',

        metaInfo() {
            return {
                title: this.$T(this.options && !this.options.canSave ? 'view' : this.isEditing ? 'edit' : 'new') + ' ' +
                    (this.options ? this.$T(this.options.singular) : this.$t('item'))
            }
        },
        components: {
            QTooltip, QSpinnerPuff
        },
        props: {
            slug: {
                type: String,
                required: true
            },
            baseRoute: {
                type: String,
                required: true
            },
            titleColor: {
                type: String,
                default: 'white'
            },
            titleInverted: {
                type: Boolean,
                default: false
            },
            color: {
                type: String,
                default: 'white'
            },
            width: {
                type: String,
                default: '100%'
            },
            footerColor: {
                type: String,
                default: 'white'
            },
            enableSubmitButton: {
                type: Boolean,
                default: true
            },
            displayHeader: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
                form: null,
                responseData: {},
                marketConfig: null,
                isLendingKitCreate: false,
            }
        },
        methods: {
            async handleFieldChange(column, value) {
                if (column.onChange) {
                    switch (column.onChange) {
                        case 'fetchLendingData':
                            if (value && column.field === 'lending_order_id') {
                                await this.fetchLendingData(value);
                            }
                            break;
                    }
                }
            },
            
            async fetchLendingData(lendingOrderId) {
                try {
                    const response = await axios.get('/api/lending-data/'+ lendingOrderId);

                    //console.log('Fetching lending data for order ID:', response.data);
                    
                    if (response.data.success) {
                        this.form.lending_kit_id = response.data.lending_kit_id;
                        this.form.lending_kit_codentify = response.data.lending_kit_codentify;
                        this.form.order_status_id = response.data.order_status_id;
                        this.form.stock_status_id = response.data.stock_status_id;
                        this.form.problemfixer = 1;
                    }
                } catch (error) {
                    console.error('Error fetching lending data:', error);
                    this.$q.notify({
                        type: 'negative',
                        message: 'Error fetching lending data'
                    });
                }
            },
            //quando o kit for vendido ninguem pode habilitalo para lending novamente
            hideComponent(column) {
                if (column.field === "enable_to_creation" && this.form.originalData.stock_status_id === 11)
                {
                    return false
                }
                if (column.field === 'enable_completed_sold' && (this.user.market.id === 2 || this.user.market.id === 3))
                {
                    return false
                }
                if (column.field === 'enable_guided_trial' && (this.form.originalData.role_id !== 6 || this.user.market.id === 2 || this.user.market.id === 3))
                {
                    return false
                }
                if (column.localField === 'lending_kit_codentify' && this.$route.name === 'admin.problem-fixer.edit')
                {
                    return false
                }
                if (column.localField === 'lending_kit_id' && this.$route.name === 'admin.problem-fixer.create')
                {
                    return false
                }
                if (column.viewable === false)
                {
                    return false
                }

                return true
            },
            /**
             *
             */
            async describe() {
                // if (!this.options)
                // In some cases (user edition, for example) we need to reload the form fields, so... no cache
                await this.$store.dispatch('crud/fetchForm', this.slug)

                let {data} = this.isEditing ?
                    await axios.get(`${this.resourceURL}?transform=false`) : {data: {model: {}}}
                let {model} = data

                await this.getConfigForMarket(model.market_id)

                let fields = {}

                let columns = this.options.columns
                // For some reason PHP casts some arrays as objects. Convert it back to array here:
                if (typeof columns === "object")
                    columns = Object.keys(columns).map(key => (columns[key]))

                const allColumns = columns.filter(column => 
                    column.editable || column.displayOnly
                );

                allColumns.forEach(column => {
                    if (column.editable || column.displayOnly) {
                        fields[column.localField || column.field] = model.hasOwnProperty(column.localField || column.field) ?
                            model[column.localField || column.field] : column.default || null
                    }
                })

                this.form = new Form(fields)
                if (this.$route.name === 'backoffice.lending-kit.create') {
                    this.form.enable_to_creation = 1
                }
                if (this.$route.name === 'admin.problem-fixer.edit' || this.$route.name === 'admin.problem-fixer.create') {
                    this.form.problemfixer = 1;
                }
            },
            /**
             * Loads the "mock data" from the store
             */
            async getMockData() {
                if (!this.mockData)
                    await this.$store.dispatch('crud/fetchMockData', this.slug + (this.$route.params.id ? `/${this.$route.params.id}` : ''))
            },
            /**
             * Check if kit exists in DataObserver
             */
             async canCreateLendingKit() {
                if (this.isLendingKitCreate) {
                    try {
                        const codentify = this.form.codentify;
                        if (!codentify) {
                            this.$q.notify({
                                type: 'negative',
                                message: this.$T('Codentify is required')
                            });
                            return false;
                        }
                        
                        const { data } = await axios.get(`/api/check-lending-kit-creation/${codentify}`);
                        if (data.response && data.response.results && data.response.results.exists) {
                            return data.response.results.exists.includes(codentify);
                        }
                        
                        return false;
                    } catch (error) {
                        console.error('Error checking if lending kit can be created:', error);
                        return false;
                    }
                }
                return true;
            },
            /**
             * Submit the form object
             */
            async submit() {
                if (this.isLendingKitCreate) {
                    const canCreate = await this.canCreateLendingKit();
                    if (!canCreate) {
                        this.$q.notify({
                            type: 'negative',
                            message: this.$T('Lending kit does not exist in DataObserver')
                        });
                        return;
                    }
                }
                
                this.form.busy = true
                if (this.form.lending_point_type_id !== 11 && this.form.enable_completed_sold === null) {
                  this.form.enable_completed_sold = true
                }

                if(this.form.problemfixer == 1){
                    this.form.status = 1;
                    try {
                        await axios.post(`/api/orders/${this.form.lending_order_id}/send-end-to-ws`);
                        this.form.status = 2;
                        this.$q.notify({
                            type: 'positive',
                            message: 'Order end sent to AD successfully'
                        });
                    } catch (error) {
                        //console.error('Error sending order end to AD:', error);
                        this.form.status = 0;
                        let errorMessage = 'Error sending order end to AD';
                        
                        if (error.response && error.response.data) {
                            const responseData = error.response.data;
                            if (responseData.error && responseData.error.message) {
                                errorMessage = responseData.error.message;
                            } else if (responseData.error && typeof responseData.error === 'string') {
                                errorMessage = responseData.error;
                            } else if (responseData.message) {
                                errorMessage = responseData.message;
                            } else if (responseData.errors && Array.isArray(responseData.errors) && responseData.errors.length > 0) {
                                errorMessage = responseData.errors[0];
                            }
                        }
                        
                        this.$q.notify({
                            type: 'negative',
                            message: errorMessage
                        });
                        this.form.busy = false
                        return;
                    }

                    delete this.form.lending_kit_codentify;

                    let {data} = await this.form[this.isEditing ? 'patch' : 'post'](this.resourceURL)
                    this.$q.dialog({
                        title: this.$T('success'),
                        message: data.success.message,
                        preventClose: true,
                        stackButtons: false,
                        ok: {
                            color: 'highlight',
                            label: this.$T('go to list'),
                            rounded: true,
                            textColor: 'primary',
                            noCaps: true
                        },
                    }).then(() => {
                        this.$router.push({name: `${this.baseRoute}.index`})
                    }).catch(() => {
                        this.$router.push({name: `${this.baseRoute}.index`})
                    })
                    this.form.busy = false
                } else {
                
                    let {data} = await this.form[this.isEditing ? 'patch' : 'post'](this.resourceURL)
                    this.$q.dialog({
                        title: this.$T('success'),
                        message: data.success.message,
                        preventClose: true,
                        stackButtons: false,
                        ok: {
                            label: `${this.$T('edit')} ${this.$t(this.options.singular)}`,
                            outline: true,
                            rounded: true,
                            color: 'primary',
                            noCaps: true
                        },
                        cancel: {
                            color: 'highlight',
                            label: this.$T('go to list'),
                            rounded: true,
                            textColor: 'primary',
                            noCaps: true
                        }
                    }).then(() => {
                        this.$router.push({name: `${this.baseRoute}.edit`, params: {id: data.model.id}})
                    }).catch(() => {
                        this.$router.push({name: `${this.baseRoute}.index`})
                    })
                    this.form.busy = false
                }            
            },

            extraDisable(field) {
                if (this.$route.name === 'backoffice.lending-point.detail') {
                    return true
                }
                if (this.isEditing) {
                    if (this.user.role.name === 'Call Center' && this.$route.name === 'backoffice.lending-kit.edit') {
                        return field !== 'stock_status.description' && field !== 'product_model.description' && field !== 'product_color.description' && field !== 'lending_point.description'
                    } else if (this.$route.name === 'backoffice.lending-kit.edit' && field === 'stock_status.description' && this.form.originalData.stock_status_id === 11) {
                        // if stock status is sold no one can mark the kit as enabled to creation
                        return true
                    }
                    if ((this.user.role.name === 'Admin' || this.user.role.name === 'Backoffice') && this.$route.name === 'backoffice.lending-point.edit')
                    {
                      if (field === 'enable_completed_sold' && this.form.lending_point_type_id !== 11) {
                        this.form.enable_completed_sold = false
                        return true
                      }
                    }
                }
                if ((this.user.role.name === 'Admin' || this.user.role.name === 'Backoffice') && this.$route.name === 'backoffice.lending-point.create')
                {
                  if (field === 'enable_completed_sold' && this.form.lending_point_type_id !== 11) {
                    this.form.enable_completed_sold = false
                    return true
                  }
                }
                return false
            },
            async getConfigForMarket(marketId) {
              if (marketId) {
                await axios.get('/api/v1/lending-point/config/' + marketId)
                    .then(res => {
                      this.marketConfig = res.data.data
                    })
              } else {
                if (this.user.role.name === 'Backoffice') {
                  await axios.get('/api/v1/lending-point/config/' + this.user.market.id)
                      .then(res => {
                        this.marketConfig = res.data.data
                      })
                }
              }
            },
        },
        mounted() {
            this.describe()
            this.getMockData()
            this.isLendingKitCreate = this.$route.name === 'backoffice.lending-kit.create'
        },
        watch: {
            slug: 'describe',
            $route: 'getMockData'
        },
        computed: {
            options() {
                return this.$store.getters['crud/formDescription'](this.slug)
            },

            mockData() {
                return this.$store.getters['crud/mockData'](this.slug + (this.$route.params.id ? `/${this.$route.params.id}` : ''))
            },

            isEditing() {
                return this.$route && this.$route.params.id
            },

            resourceURL() {
                return `${config.appUrl}/api/${this.slug}/${this.isEditing ? this.$route.params.id : ''}`
            },

            submitLabel() {
                return !this.isEditing ? this.$T('save') : this.$t('update')
            },

            loadingLabel() {
                return !this.isEditing ? this.$T('saving...') : this.$T('updating...')
            },

            successMessage() {
                return getNested('success.message', this.responseData)
            },

            ...mapGetters({
                user: 'auth/user'
            }),
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/AutoForm.vue